import script from "./CoachingSessionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoachingSessionView.vue?vue&type=script&lang=ts&setup=true"

import "./CoachingSessionView.vue?vue&type=style&index=0&id=40050eea&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40050eea"]])

export default __exports__